import React, { Suspense, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Alert, Layout, Spin, Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { appSelector } from "../helpers/appSelector";
import { clearStates, getFilesRequest } from "../store/bulk-payment";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../helpers/appDispatch";
import { useEffect } from "react";
import { path } from "../helpers/path";
import FileUpload from "../components/bulkPayment/FileUplaod";
import DataTable from "../components/bulkPayment/DataTable";

const Files = React.lazy(() => import("../components/bulkpayment-pages/PaymentFiles"));
const { Content } = Layout;

const BulkPayment = () => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { files, filesTotal, loadingFiles, uploadSuccess, isSubmitting, error } = appSelector((state) => state.bulkPayment);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const getErrorMessage = (error: any) => {
    if (typeof error === "string") return error;
    return error?.detail || error?.message || error?.title || JSON.stringify(error);
  };

  useEffect(() => {
    dispatch(clearStates());
    dispatch(getFilesRequest({ pageSize: 10, skip: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data: string = JSON.stringify(files);
    localStorage.setItem("status", data);
  }, [files]);

  const onClickRow = (fileId: number) => {
    history.push(`${path.file}/${fileId}`);
  };

  const handleNewPayment = () => {
    dispatch(clearStates());
    setShowFileUpload(true);
  };

  const handleBack = () => {
    setShowFileUpload(false);
    setCurrentPage(1);
    dispatch(getFilesRequest({ pageSize: 10, skip: 0 }));
  };

  const onLoadMore = (page: number, pageSize: number) => {
    setCurrentPage(page);
    dispatch(getFilesRequest({ pageSize, skip: page - 1 }));
  };

  const renderContent = () => {
    if (showFileUpload) {
      if (uploadSuccess) {
        return (
          <div className="mt-20">
            <DataTable loading={isSubmitting} translate={t} onBack={handleBack} />
          </div>
        );
      }
      return <FileUpload onBack={handleBack} />;
    }
    return (
      <>
        <div className="margin-top">
          <Row style={{ position: "relative" }}>
            <h4 className="transaction-chart-text">
              {t("general.bulkPayments")}
            </h4>
            <div className="utility-buttons">
              <Button
                type="primary"
                className="export-buttons"
                onClick={handleNewPayment}
              >
                {t("general.newBulkPayment")}
              </Button>
            </div>
          </Row>
        </div>
        <Files
          files={files}
          onClickRow={onClickRow}
          onLoadMore={onLoadMore}
          loading={loadingFiles}
          translate={t}
          total={filesTotal}
          currentPage={currentPage}
        />
        {error && !loadingFiles ? (
          <Alert
            message={t("general.failedToFetch")}
            description={getErrorMessage(error)}
            type="error"
            showIcon
          />
        ) : null}
      </>
    );
  };

  return (
    <div className="padding-box">
      <Content className="site-layout-background site-box">
        <Suspense
          fallback={
            <Row className="suspense-container">
              <div style={{ marginTop: "200px" }}>
                <Spin />
              </div>
            </Row>
          }
        >
          {renderContent()}
        </Suspense>
      </Content>
    </div>
  );
};

export default withRouter(BulkPayment);
